import FileUploader from "@/components/FileUploader";
import AttachedDocument from "@/components/job/AttachedDocument";
import { Typography } from "@/components/ui";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection9Props = {
  attachments: RepairIntakeFormData["section9"]["attachments"];
  errorMessage?: string;
  onAddAttachment: (payload: { file: File }) => void;
  onRemoveAttachment: (index: number) => void;
};

export function RepairIntakeSection9({
  attachments,
  errorMessage,
  onAddAttachment,
  onRemoveAttachment,
}: RepairIntakeSection9Props) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Typography variant="text-small" weight="medium">
          Upload all documents and pictures for this repair *
        </Typography>
        <Typography variant="text-small" className="text-gray-600">
          Upload up to 10 supported files. Max 100 MB per file.
        </Typography>
      </div>

      {attachments.length ? (
        <div className="flex flex-wrap gap-4">
          {attachments.map((file, index) => (
            <AttachedDocument
              key={`${file.name}-${file.size}-${file.lastModified}`}
              document={{ name: file.name, size: file.size, type: file.type || "file" }}
              onDelete={() => onRemoveAttachment(index)}
            />
          ))}
        </div>
      ) : null}

      <FileUploader
        withPreview={false}
        setFile={onAddAttachment}
        description="All file types supported (max. 100MB)"
        fileTypesRegex={/.*/}
        inputAcceptFiles="*/*"
        maxFileSizeMB={100}
      />
      <Typography variant="validationError">{errorMessage}</Typography>
    </div>
  );
}
